import {lazy} from 'react';

export const APITableLazy = lazy(() => import(/* webpackChunkName: "apiTable" */ '.'));
